import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

interface IWrapperProps {
  editImagesActive: boolean;
}

export const Wrapper = styled.div`
  height: 360px;
  width: 360px;
  margin: 10px;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
  box-shadow: rgb(220, 220, 220) 0px 0px 15px;
  z-index: ${(props: IWrapperProps) => props.editImagesActive && "1"};

  .slick-dots {
    bottom: 25px;
  }

  .slick-dots li button:before {
    color: #fff;
    opacity: 0.8;
    font-size: 14px;
  }

  .slick-dots li.slick-active button:before {
    color: #f2008c;
  }

  ${mediaMaxWidth.smallDesktop} {
    margin: 0 auto;
  }

  ${mediaMaxWidth.phone} {
    height: 300px;
    height: ${(props: IWrapperProps) => props.editImagesActive && "360px"};
    border-bottom: ${(props: IWrapperProps) =>
      props.editImagesActive && "20px solid #e4e5e7"};
    width: 100vw;
    border-radius: 0;

    .slick-dots {
      bottom: 70px;
    }

    .slick-dots li {
      margin: 0 10px;
    }

    .slick-dots li button:before {
      color: #fff;
      opacity: 0.8;
      font-size: 16px;
    }
  }

  ${mediaMaxWidth.smallPhone} {
    height: 280px;
  }
`;

export const Slide = styled.div`
  &:focus {
    outline: none;
  }
`;

export const Image = styled.img`
  height: 360px;
  width: 360px;
  object-fit: cover;
  border-radius: 8px;

  ${mediaMaxWidth.phone} {
    height: 300px;
    width: 100vw;
    border-radius: 0;
  }

  ${mediaMaxWidth.smallPhone} {
    height: 280px;
  }
`;

export const SliderPlaceholder = styled.div`
  height: 320px;
  width: 360px;
  object-fit: cover;
  background-color: #fff;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    font-size: 3em;
    color: #e4e5e7;
  }

  ${mediaMaxWidth.phone} {
    height: 300px;
    width: 100vw;
    border-radius: 0;
  }

  ${mediaMaxWidth.smallPhone} {
    height: 280px;
  }
`;
